export default "__VITE_ASSET__r7Y$oGkJ__"